import * as types from "./actionTypes";

export const addSignal = (id) => async (dispatch) => {
    dispatch({
        type: types.ADD_SIGNAL,
        id:id
    });
};
